/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './op-procedure-order-item.reducer';

export const OpProcedureOrderItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const opProcedureOrderItemEntity = useAppSelector(state => state.opProcedureOrderItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="opProcedureOrderItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.opProcedureOrderItem.detail.title">OpProcedureOrderItem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.opProcedureOrderItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{opProcedureOrderItemEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.opProcedureOrderItem.active">Active</Translate>
            </span>
          </dt>
          <dd>{opProcedureOrderItemEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.opProcedureOrderItem.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{opProcedureOrderItemEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.opProcedureOrderItem.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{opProcedureOrderItemEntity.timestampEntry}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.opProcedureOrderItem.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{opProcedureOrderItemEntity.lastUpdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.opProcedureOrderItem.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{opProcedureOrderItemEntity.cursor}</dd>
          <dt>
            <span id="totalCost">
              <Translate contentKey="tinyMedicRestApp.opProcedureOrderItem.totalCost">Total Cost</Translate>
            </span>
          </dt>
          <dd>{opProcedureOrderItemEntity.totalCost}</dd>
          <dt>
            <span id="notes">
              <Translate contentKey="tinyMedicRestApp.opProcedureOrderItem.notes">Notes</Translate>
            </span>
          </dt>
          <dd>{opProcedureOrderItemEntity.notes}</dd>
          <dt>
            <span id="orderStatus">
              <Translate contentKey="tinyMedicRestApp.opProcedureOrderItem.orderStatus">Order Status</Translate>
            </span>
          </dt>
          <dd>{opProcedureOrderItemEntity.orderStatus}</dd>
          <dt>
            <span id="procedureStatus">
              <Translate contentKey="tinyMedicRestApp.opProcedureOrderItem.procedureStatus">Procedure Status</Translate>
            </span>
          </dt>
          <dd>{opProcedureOrderItemEntity.procedureStatus}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.opProcedureOrderItem.order">Order</Translate>
          </dt>
          <dd>{opProcedureOrderItemEntity.order ? opProcedureOrderItemEntity.order.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.opProcedureOrderItem.procedure">Procedure</Translate>
          </dt>
          <dd>{opProcedureOrderItemEntity.procedure ? opProcedureOrderItemEntity.procedure.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.opProcedureOrderItem.exam">Exam</Translate>
          </dt>
          <dd>{opProcedureOrderItemEntity.exam ? opProcedureOrderItemEntity.exam.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.opProcedureOrderItem.tooth">Tooth</Translate>
          </dt>
          <dd>{opProcedureOrderItemEntity.tooth ? opProcedureOrderItemEntity.tooth.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.opProcedureOrderItem.surface">Surface</Translate>
          </dt>
          <dd>{opProcedureOrderItemEntity.surface ? opProcedureOrderItemEntity.surface.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/op-procedure-order-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/op-procedure-order-item/${opProcedureOrderItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default OpProcedureOrderItemDetail;
